import React, { useContext, useEffect } from 'react';
import cx from 'classnames';
import Context from '../../context/context';

import './establishment-type-toggle.css';

const EstablishmentTypeToggle = () => {
  const { selectedCategory, updateSelectedCategory, establishmentTypes } =
    useContext(Context);

  useEffect(() => {
    updateSelectedCategory(null);
  }, [updateSelectedCategory]);

  return (
    <div
      className="establishment-type-toggle"
      role="group"
      aria-label="Establishment type"
    >
      {establishmentTypes.map((type) => {
        const typeToUse = type === 'All Categories' ? null : type;
        const isSelected =
          selectedCategory === type ||
          (type === 'All Categories' && !selectedCategory);

        return (
          <button
            type="button"
            key={type}
            onClick={() => {
              if (isSelected && type !== 'All Categories') {
                updateSelectedCategory(null);
                return;
              }
              updateSelectedCategory(typeToUse);
            }}
            className={cx('establishment-type-toggle-button', {
              'establishment-type-toggle-button--selected': isSelected,
            })}
            aria-pressed={isSelected}
          >
            {type}
          </button>
        );
      })}
    </div>
  );
};

EstablishmentTypeToggle.propTypes = {};

EstablishmentTypeToggle.defaultProps = {};

export default EstablishmentTypeToggle;
